export interface OhsDate extends String {}
export class OhsTime {
  hours: number;

  minutes: number;

  constructor(hours: number, minutes: number) {
    this.hours = hours;
    this.minutes = minutes;
  }

  public get12HourString(): string {
    const AmOrPm = this.hours >= 12 ? 'PM' : 'AM';
    const hours12Number = this.hours % 12 || 12;
    const hours12String = hours12Number > 9 ? String(hours12Number) : `0${String(hours12Number)}`;
    const minutes12String = this.minutes > 9 ? String(this.minutes) : `0${String(this.minutes)}`;
    return `${hours12String}:${minutes12String} ${AmOrPm}`;
  }
}
export interface OhsTimezone extends String {}
